import template from './template.html'

angular
  .module('contabilidad.polizasexternas')
  .component('contabilidadPolizasexternasCobranzaLista', {
    controller: ContabilidadPolizasexternasCobranzaListaComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })

function ContabilidadPolizasexternasCobranzaListaComponent (PolizasExternasCobranza, $filter, $file) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.descargar = descargar

  function $onInit () {
    $ctrl.promise = PolizasExternasCobranza.get($ctrl.busqueda)
      .then(function (resolve) {
        $ctrl.data = resolve.data
      })
  }

  function descargar () {
    var texto = codificar(1),
      fecha = $filter('date')(new Date(), 'yyyyMMdd')
    var blob = new File([texto], {type: 'text/plain;'})
    $file.saveAs(blob, 'PolizaCobranza_' + fecha + '.txt')
  }

  var verificarCadena = $filter('rPad')

  function codificar (inicio_poliza) {
    var cadena = '',
      cadA = 'P  AAAAMMDD    1      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\r\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \r\n'
    /*var referencias = $ctrl.data.reduce(function (prev, next) {
      return prev.concat(prev.indexOf(next.referencia) < 0 ? [next.referencia] : [])
    }, [])*/
    // var vuelta = -1
    // referencias.forEach(function (referencia, index) {
      $ctrl.data.forEach(function (item, index) {
        // if (item.referencia === referencia) {
          var fecha = $filter('date')(item.fecha, 'dd-MM-yyyy')
          if (index === 0) {
            cadena += cadA
              .replace('AAAAMMDD', $filter('date')(item.fecha, 'yyyyMMdd'))
              .replace('JJJJ', ('000' + (inicio_poliza + index)).slice(-4))
              .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('Cobranza del dia ' + fecha, 60))
          }
          item.detalles.forEach(function (detalle) {
            if (detalle.importe != 0) {
              cadena += cadB
                .replace('CCCCCCCCCCCCCCCC', verificarCadena(detalle.cuenta_contable.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', verificarCadena(detalle.nota, 15))
                .replace('*', detalle.naturaleza)
                .replace('YYYYYYYYY', verificarCadena((parseFloat(detalle.importe).toFixed(2)), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena('Cobranza del dia ' + fecha, 43))
            }
          })
        // }
      })
    // })
    return cadena
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/cobranza/lista/component.js